<template>
  <div class="keypoint u-cursor-pointer u-bg-white" :class="{'is-active': isVisible, 'is-selected': isSelected}" @click.stop="$emit('click')">
    <div class="keypoint__main u-box-1by1 u-bg-white u-force-3d" v-if="$device.isFirefox" />
    <div class="keypoint__point u-bg-pink-orange"></div>
    <img src="/images/pulse.gif" class="keypoint__pulse u-wrapper-panel" v-if="!$device.isFirefox">
  </div>  
</template>

<script>
import Object3d from '@/plugins/Dom3d/mixin'

export default {
  mixins: [Object3d],

  props: {
    isSelected: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.keypoint
  width 20px
  height 20px
  opacity 0
  border-radius 50%
  transition opacity .3s linear
  
  @media ( max-width: $mq-breakpoints.tablet )
    width 30px
    height 30px
  
  &.is-active
    opacity 1
  
  &__main
    border-radius 50%
    transition transform .3s ease-in-out-quart
  
  &:hover &__main, &.is-selected &__main
    transform scale(.8, .8)

  &__pulse
    position absolute
    top -50%
    left -50%
    width 200%
    height 200%
    opacity 1
    transition opacity .3s linear

  &.is-selected &__pulse
    opacity 0

  &__point
    position absolute
    height 6px
    width 6px
    top calc( 50% - 3px )
    left calc( 50% - 3px )
    border-radius 50%
    opacity 0
    transform scale(0, 0)
    transition transform .3s ease-in-out-quart
  
    // &:after
    //   content ''
    //   display block
    //   position absolute
    //   border-radius: 50%
    //   height 4px
    //   width 4px
    //   top calc( 50% - 2px )
    //   left calc( 50% - 2px )
    //   background-color $colors.white

  &.is-selected &__point
    transform scale(1, 1)
    opacity 1

@keyframes pulse
  from
    transform: translateZ(0) scale(.5)
    opacity 1

  to
    transform: translateZ(0) scale(1)
    opacity 0

</style>